// Nav scroll shadow
const nav = document.getElementById('nav');
if (nav) {
  window.addEventListener('scroll', () => nav.classList.toggle('scrolled', scrollY > 60), { passive: true });
}

// Scroll reveal
const obs = new IntersectionObserver(
  entries => entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('on'); }),
  { threshold: 0.1 }
);
document.querySelectorAll('.u').forEach(el => obs.observe(el));

// Countdown to 04 Sep 2026
const TARGET = new Date('2026-09-04T00:00:00');
const pad = n => String(n).padStart(2, '0');
function tick() {
  const diff = TARGET - Date.now();
  if (diff <= 0) return;
  const d = document.getElementById('cd-d');
  const h = document.getElementById('cd-h');
  const m = document.getElementById('cd-m');
  const s = document.getElementById('cd-s');
  if (d) d.textContent = pad(Math.floor(diff / 86400000));
  if (h) h.textContent = pad(Math.floor(diff % 86400000 / 3600000));
  if (m) m.textContent = pad(Math.floor(diff % 3600000 / 60000));
  if (s) s.textContent = pad(Math.floor(diff % 60000 / 1000));
}
tick();
setInterval(tick, 1000);
